import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "dot glow-dot"
}

import { useUserStore } from '@/stores/user';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'contactService',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const router = useRouter()
const userStore = useUserStore()
const props = __props
const messageCount = computed(() => userStore.unreadCount)
const goToNotifications = () => {
    router.push('/sd-message')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "rotating-image",
      src: _ctx.itemData.url,
      alt: "",
      onClick: goToNotifications
    }, null, 8, _hoisted_2),
    (messageCount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})